import { crypto } from "../crypto.js";

type DimensionParams = {
  id?: string;
  group_id: string;
  document_id: string;
  page_id: string;
  index?: number;
  type?: 'aligned' | 'rectangular',
  scale?: string;
  data?: object;
  scale_reference?: 'screen_space' | 'paper_space';
  size?: number;
  color_override?: string | null;
  display_unit?: string;
  format?: string;
  decimal_precision?: number;
  fractional_precision?: number;
  mm_precision?: number;
};

function createDimension({
  id = crypto.randomUUID(),
  group_id,
  document_id,
  page_id,
  index = 0,
  type = 'aligned',
  scale = '1in:1in',
  data = {},
  scale_reference = 'screen_space',
  size = 10,
  color_override = null,
  display_unit = 'inches',
  format = 'FRACTIONAL',
  decimal_precision = 2,
  fractional_precision = 4,
  mm_precision = 0,
}: DimensionParams) {
  return {
    id,
    group_id,
    document_id,
    page_id,
    index,
    type,
    scale,
    data,
    scale_reference,
    size,
    color_override,
    display_unit,
    format,
    decimal_precision,
    fractional_precision,
    mm_precision,
  };
}

export { createDimension };
